import { Component } from '@angular/core';

import { ToastrService } from 'ngx-toastr';
import { EMPTY, catchError } from 'rxjs';

import {
  CartItemConverted,
  CartService,
  CartTotalsConverted,
  ConfigService,
  EventsService,
  SRouterLinkWithHrefDirective,
  TaxService,
  TranslatePipe,
} from '@speedy/core';
import { AsyncPipe } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { SpeedyLinkButtonComponent } from '../../speedy-link-button/speedy-link-button.component';
import { PriceComponent } from '../../price/price.component';
import { CurrencyComponent } from '../../currency/currency.component';
import { MatIcon } from '@angular/material/icon';
import { MatMenuTrigger, MatMenu } from '@angular/material/menu';

@Component({
  selector: 'app-top-cart',
  templateUrl: './top-cart.component.html',
  styleUrls: ['./top-cart.component.scss'],
  standalone: true,
  imports: [
    MatMenuTrigger,
    MatIcon,
    MatMenu,
    SRouterLinkWithHrefDirective,
    CurrencyComponent,
    PriceComponent,
    SpeedyLinkButtonComponent,
    MatProgressSpinner,
    AsyncPipe,
    TranslatePipe,
  ],
})
export class TopCartComponent {
  loading = false;

  mediaUrl = this.configService.getProductMediaUrl('thumb');
  placeholder = this.configService.getPlaceholder();

  cart$ = this.cartService.subscribeToCart();

  constructor(
    private taxService: TaxService,
    private cartService: CartService,
    private configService: ConfigService,
    private eventsService: EventsService,
    private alertService: ToastrService,
  ) {}

  getRowTotal(row: CartItemConverted) {
    return this.taxService.getRowTotal(row);
  }

  getSubtotal(cart: CartTotalsConverted) {
    return this.taxService.getSubtotal(cart);
  }

  deleteItem(row: CartItemConverted, event: MouseEvent) {
    event.stopPropagation();

    this.loading = true;
    this.eventsService.broadcast('remove_from_cart', row);

    this.cartService
      .deleteItem(row.item_id)
      .pipe(
        catchError((error) => {
          this.loading = false;
          this.alertService.error(error.error?.message ?? error.error);
          return EMPTY;
        }),
      )
      .subscribe(() => {
        this.loading = false;
      });
  }
}
